import React from 'react';

import {Switch} from "../misc/switch/switch";
import {ScoresListWidgetHeaderDesktopProps} from "./scores-header";

export class ScoresHeaderDesktopLiveProps extends ScoresListWidgetHeaderDesktopProps {
  switchOnClick: Function;
  liveGamesCount: Number;
}

export const ScoresHeaderLive = (props: ScoresHeaderDesktopLiveProps) => {
  const onClick = (isActive: Boolean) => {
    props.switchOnClick && props.switchOnClick(isActive);
  }

  const switchProps = {
    isActive: props.isLive,
    label: props.controller.state.terms.WEB_LIVE_TOGGLE,
    badgeLabel: props.liveGamesCount,
    shouldRenderBadge: props.liveGamesCount > 0,
    activeButtonClassName: 'scores-header-live-switch-active-button',
    onClick: (isLive: Boolean) => onClick(isLive)
  }

  return (
    <Switch {...switchProps}/>
  )
}
